/**
 * Derive ISO country code and a human "city" label from Google Places address_components.
 * Autocomplete often omits `locality` (e.g. uses postal_town, admin_area_level_2, sublocality).
 */
export function extractCountryAndCityFromPlace(place: google.maps.places.PlaceResult): {
  countryCode?: string;
  city?: string;
} {
  const components = place.address_components ?? [];
  let countryCode: string | undefined;

  for (const c of components) {
    if (c.types?.includes('country')) {
      countryCode = c.short_name?.trim() || undefined;
      break;
    }
  }

  const cityTypeOrder = [
    'locality',
    'postal_town',
    'administrative_area_level_2',
    'administrative_area_level_3',
    'sublocality_level_1',
    'sublocality_level_2',
    'sublocality',
    'neighborhood',
    'administrative_area_level_1',
  ];

  for (const t of cityTypeOrder) {
    const c = components.find(comp => comp.types?.includes(t));
    const name = c?.long_name?.trim();
    if (name) {
      return { countryCode, city: name };
    }
  }

  if (place.types?.includes('locality') && place.name?.trim()) {
    return { countryCode, city: place.name.trim() };
  }

  return { countryCode, city: undefined };
}
